import { Component } from 'react';
import classNames from 'classnames/bind';

import PricingFAQItem from './PricingFAQItem';
import PricingFAQFooter from './PricingFAQFooter';
import withComponentName from '../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class PricingFAQ extends Component {
  state = {
    activeFAQid: null,
  };

  setActiveFAQid = id => {
    const { activeFAQid } = this.state;

    this.setState({
      activeFAQid: activeFAQid !== id ? id : null,
    });
  };

  render() {
    const { activeFAQid } = this.state;
    const { FAQList, withFooter } = this.props;

    return (
      <div className={cx('PricingFAQ')}>
        <div className={cx('PricingFAQ__head')}>
          FREQUENTLY ASKED QUESTIONS
        </div>

        {FAQList.map(({ question, answer }, index) => (
          <PricingFAQItem
            key={index}
            question={question}
            answer={answer}
            id={index}
            activeFAQid={activeFAQid}
            setActiveFAQid={this.setActiveFAQid}
          />
        ))}

        {withFooter && (
          <PricingFAQFooter hideForSmallDevices />
        )}
      </div>
    );
  }
}

export default withComponentName(PricingFAQ);
